import { useState } from "react";

import { BdsButton, BdsIconWarning, BdsIconX, BdsLink, BdsText } from "@buildertrend/components";

import { BTLocalStorage } from "types/btStorage";

import { isBrowserSupported } from "utilities/document/isBrowserSupported";

import "./BrowserSupportedWarning.less";

const KEY = "bt-string-hideBrowserNotSupportedTime" as const;
const SHOW_EVERY = 4 * 60 * 60 * 1000; // 4 hours

export function BrowserSupportedWarning() {
    // will show if reloaded after SHOW_EVERY time has passed
    const [supported, setSupported] = useState<boolean>(() => {
        const dismissedAt: number = Date.parse(BTLocalStorage.get(KEY) || "0") + SHOW_EVERY;
        const now: number = Date.now();
        if (dismissedAt && dismissedAt > now) {
            return true;
        }
        return isBrowserSupported();
    });
    const handleDismiss = () => {
        BTLocalStorage.set(KEY, new Date().toISOString());
        setSupported(true);
    };
    if (!supported) {
        return (
            <div className="flex flex-col browser-supported-warning-container">
                <div className="flex flex-row browser-supported-warning">
                    <BdsIconWarning />
                    <BdsText tag="p" size="normal-md">
                        You are using an unsupported browser. For the best experience, please use
                        the latest version of&nbsp;
                        <BdsLink
                            testid="chrome"
                            to="https://www.google.com/chrome/"
                            target="_blank"
                            rel="noopener"
                            className="px-4"
                        >
                            Google Chrome
                        </BdsLink>
                        ,&nbsp;
                        <BdsLink
                            testid="firefox"
                            to="https://www.mozilla.org/firefox/"
                            target="_blank"
                            rel="noopener"
                        >
                            Firefox
                        </BdsLink>
                        ,&nbsp;
                        <BdsLink
                            testid="edge"
                            to="https://www.microsoft.com/edge"
                            target="_blank"
                            rel="noopener"
                        >
                            Edge
                        </BdsLink>
                        , or&nbsp;
                        <BdsLink
                            testid="safari"
                            to="https://www.apple.com/safari/"
                            target="_blank"
                            rel="noopener"
                        >
                            Safari
                        </BdsLink>
                        .
                    </BdsText>
                    <BdsButton
                        testid="close-browser-warning"
                        icon={<BdsIconX />}
                        displayType="tertiary"
                        ariaLabel="Close"
                        onClick={() => handleDismiss()}
                    />
                </div>
            </div>
        );
    }
    return null;
}
